import { render } from "./MyAuctions.vue?vue&type=template&id=23038af8&scoped=true"
import script from "./MyAuctions.vue?vue&type=script&lang=js"
export * from "./MyAuctions.vue?vue&type=script&lang=js"

import "./MyAuctions.vue?vue&type=style&index=0&id=23038af8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23038af8"]])

export default __exports__